import {
  NAME_REGION,
  MULTICITY_PARAM,
  DEFAULT_DASHBOARD,
  COMPARE_BAR,
  COMPARE_PIE_OPTION,
  COMPARE_PIE_BOOL,
  OVERLAP_OPT,
  BARCHART_FOR_MEAS,
  CITIES_COORDINATES
} from "./../../shared/const";
import { defaultIdDisplayed, genericChartIds } from "./../../shared/data";
import { Component, OnInit, Input } from "@angular/core";

import { OnChanges } from "@angular/core/src/metadata/lifecycle_hooks";
import { Helper } from "./../../shared/helper";
import { ChartsService } from "./charts.service";
import {
  chartOptionsBarChart,
  chartOptionsMobilityChart,
  chartType,
  chartOptionsPiechart,
  chartOptionsAreachart,
  chartOptionsLinechart
} from "./chart.data";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Logger } from "app/shared";
import { trigger, transition, style, animate } from "@angular/animations";
import { LoaderService } from "app/shared";
import { DataCollectionService } from "app/shared/services/data-collection.service";
import { FilterOptionService } from "app/features/filter-options/filter-options.service";
import { DataInteraction, CityCoordinates } from "app/shared/data-interaction";
import * as uikit from "uikit";
import { City } from "../filter-options/city";

@Component({
  selector: "app-charts",
  templateUrl: "./charts.component.html",
  animations: [
    trigger("enterAnimation", [
      transition(":enter", [
        style({ height: "0px", transform: "translateY(-100%)", opacity: 0 }),
        animate(
          "500ms",
          style({ height: "250px", transform: "translateY(0)", opacity: 1 })
        )
      ]),
      transition(":leave", [
        style({ height: "250px", transform: "translateY(0)", opacity: 1 }),
        animate(
          "500ms",
          style({ height: "0px", transform: "translateY(-100%)", opacity: 0 })
        )
      ])
    ])
  ],
  styleUrls: ["./charts.component.scss"]
})
export class ChartsComponent implements OnChanges {
  @Input() dataFilters: DataInteraction;
  @Input() dashToDisplay;
  @Input() configData;

  private title = "DASHBOARD";
  private pieChartWidth: String;
  private multiCity = MULTICITY_PARAM;
  bar = "bar";
  private _chartType = chartType;
  private chartParam; // parameters for the charts of the current dashboard (read from config file)
  private imageParam;
  private chartsToCompute;
  private chartData = {}; // contains data for rendering the all charts (all the charts received by the get request)
  private datasetView = [];
  private selectedCity;
  private comparePieChartParam = COMPARE_PIE_BOOL;
  private comparePieOption = COMPARE_PIE_OPTION;
  public makeTest: boolean;
  public selectedItemsList: any;
  private comparingYearForPie: number;
  private comparingRegionForPie: string;
  private overlapOpt = OVERLAP_OPT;
  private overlapOpt_bool: boolean;
  private barChartForMeas = BARCHART_FOR_MEAS;
  private barChartForMeas_bool: boolean;
  private date;
  private genericChartIds = genericChartIds;
  private chartYears; // use the define which year should be displayed in the charts of the current "dashboard tab"

  /* stores coordinates and zoom for making request to map geoadmin
  default is origin (Bern) with no zoom */
  private city_coordinates: CityCoordinates = {
    coordinateE: 2600000,
    coordinateN: 1200000,
    mapZoom: 1
  };

  constructor(
    private dataCollectionService: DataCollectionService,
    private helper: Helper,
    private chartsService: ChartsService,
    private translateService: TranslateService,
    private logger: Logger,
    private filterOptionsService: FilterOptionService
  ) {}

  get chartType() {
    return this._chartType;
  }

  ngOnChanges(changes) {
    // update the local configuration data once received from parent
    if (changes.configData) {
      this.updateConfigdata();
      // update filter only when configData changes because there is a switch from another subnav (i.e. information, map)
      // not the first change (component creation) and filter should already be defined
      if (!changes.configData.firstChange && this.dataFilters) {
        this.updateFilterValues();
      }
    }
    if (changes.dashToDisplay) {
      // update configuration to match the selected dashboard
      this.updateConfigdata();

      // update the filter values according to the selected dashboard
      // except on first change because it's the default or previous dash when to component is created (and it changes quickly after)
      if (!changes.dashToDisplay.firstChange) {
        this.updateFilterValues();
      }
    } else if (!this.helper.isNullOrUndefined(changes.dataFilters)) {
      // Update the charts when the filters change
      // Update the charts only if the filters are defined
      if (!this.helper.isNullOrUndefined(changes.dataFilters.currentValue)) {
        // proceed differently if the energy service filter is displayed
        if (this.isEnergyServiceFilterDisplayed()) {
          // read the filters values
          const currentFiltersValues = changes.dataFilters.currentValue;
          // proceed only if the filter for energy service is defined
          if (
            !this.helper.isNullOrUndefined(currentFiltersValues.energy_service)
          ) {
            // test if AT LEAST 1 energy service is selected
            if (currentFiltersValues.energy_service.length >= 1) {
              // Yes, update the charts
              this.update();
            } else {
              // No, don't display the charts
              this.chartParam.map(ch => {
                this.deleteChartData(ch.id);
              });
            }
          }
        } else {
          this.update();
        }
      }
      /* update the selected city information
      must be done here because the selected city is updated in this.update */
      this.updateCityCoordinates(this.selectedCity);
    }
  }

  isEnergyServiceFilterDisplayed(): boolean {
    let isDisplayed = false;
    if (this.configData && this.dashToDisplay) {
      this.configData["dashboards"][this.dashToDisplay][
        "filters"
      ].map(filterData => {
        isDisplayed =
          isDisplayed || filterData["filterName"] == "energyService";
      });
    }
    return isDisplayed;
  }

  updateConfigdata() {
    if (this.configData && this.dashToDisplay) {
      this.barChartForMeas = this.configData["dashboards"][
        this.dashToDisplay.toLowerCase()
      ]["barChartForMeasuredData"];

      this.chartParam = this.configData["dashboards"][
        this.dashToDisplay.toLowerCase()
      ]["charts"];

      this.imageParam = this.configData["dashboards"][
        this.dashToDisplay.toLowerCase()
      ]["images"];

      if (this.comparePieChartParam == "True") {
        this.pieChartWidth = "46%";
      } else {
        this.pieChartWidth = "98%";
        this.comparePieOption = null;
      }

      this.chartYears = this.configData["dashboards"][
        this.dashToDisplay.toLowerCase()
      ]["chartYears"];
    }
  }

  updateFilterValues() {
    // update the filter values only if all the necessary data is available (configuration and selected dashboard)
    if (this.configData && this.dashToDisplay) {
      let filterValues = {};
      const currentDashboard = this.configData["dashboards"][
        this.dashToDisplay.toLowerCase()
      ];
      const kpiNamesFromConfig: string[] = currentDashboard["kpis"].map(
        kpi => kpi["id"]
      );
      const yearFilter = currentDashboard["filters"].filter(
        filter => filter.filterName == "yearSelector"
      );
      const selectedCity = this.filterOptionsService
        .getDataFilter()["cities"]
        .filter(city => city.selected)[0];

      currentDashboard["filters"].forEach(filterConfig => {
        filterValues[filterConfig["filterName"]] = filterConfig["filterValue"];
      });

      let kpiNames = kpiNamesFromConfig; // default use year from kpis
      let desiredYears = [];
      let descendingOrder = undefined;
      // check if user configured the values for the years
      if (yearFilter && yearFilter.length > 0 && yearFilter[0]["filterValue"]) {
        descendingOrder = yearFilter[0]["filterValue"]["descending"];
        // use hard coded years and ignor kpis if provided
        if (yearFilter[0]["filterValue"]["years"]) {
          kpiNames = [];
          desiredYears = yearFilter[0]["filterValue"]["years"];
        }
      }

      this.filterOptionsService.updateYears(
        kpiNames,
        selectedCity.objectId,
        desiredYears,
        descendingOrder
      );

      this.filterOptionsService.setDefaultFilterValues(filterValues);
    }
  }

  updateCityCoordinates(city: City) {
    if (city && CITIES_COORDINATES[city.name.toLowerCase()]) {
      this.city_coordinates = {
        coordinateE: CITIES_COORDINATES[city.name.toLowerCase()].coordinateE,
        coordinateN: CITIES_COORDINATES[city.name.toLowerCase()].coordinateN,
        mapZoom: CITIES_COORDINATES[city.name.toLowerCase()].mapZoom
      };
    }
  }

  public changeSelection(chart_param) {
    this.selectedItemsList = chart_param.objectivesInfo.filter(
      (value, index) => {
        return value.isChecked;
      }
    );
  }

  getChartOption(type) {
    if (type == this._chartType.bar) {
      chartOptionsBarChart["maintainAspectRatio"] = false;
      chartOptionsBarChart.legend.display = false;
      return chartOptionsBarChart;
    } else if (type == this._chartType.piechart) {
      return chartOptionsPiechart;
    } else if (type == this._chartType.area) {
      return chartOptionsAreachart;
    } else if (type == this._chartType.line) {
      return chartOptionsLinechart;
    }
  }

  getMobilityChartOption() {
    return chartOptionsMobilityChart;
  }

  getTranslatedTitle(data) {
    return this.translateService
      .instant("FILTERS.TYPE." + data.toUpperCase())
      .replace("<sub>", "")
      .replace("</sub>", "");
  }

  getTranslatedCity(city) {
    return this.translateService.instant('CITIES.' + city);
  }

  getChartIdToUpdate(filteringDict) {
    var filteredArray = [];
    for (let i = 0; i < filteringDict.length; i++) {
      filteredArray.push(filteringDict[i]["id"]);
    }
    return filteredArray;
  }
  createPayload() {
    if (this.chartParam) {
      this.chartsToCompute = this.getChartIdToUpdate(this.chartParam);
    } else {
      this.chartsToCompute = this.dataFilters.charts;
    }
    this.selectedCity = this.dataFilters.cities.filter(
      x => x.selected === true
    )[0];
    const comparedCity = [];
    let cityId;
    this.dataFilters.cities.filter(data => {
      if (data.toCompare) {
        comparedCity.push(data.objectId);
      }
    });
    if (this.comparePieChartParam) {
      if (this.comparePieOption == "region") {
        this.comparingRegionForPie = "region"; //this.comparePieOption.toString();
        this.comparingYearForPie = null;
      } else if (Number.isInteger(parseInt(this.comparePieOption))) {
        this.comparingYearForPie = parseInt(this.comparePieOption);
        this.comparingRegionForPie = null;
      } else {
        this.comparingYearForPie = null;
        this.comparingRegionForPie = null;
      }
    } else {
      this.comparingYearForPie = null;

      this.comparingRegionForPie = null;
    }
    if (this.helper.isNullOrUndefined(this.selectedCity)) {
      cityId = defaultIdDisplayed;
      this.datasetView = this.dataFilters.energy_service;
    } else {
      cityId = this.selectedCity.objectId;
      this.datasetView = this.dataFilters.energy_service;
    }
    if (this.overlapOpt === "True") {
      this.overlapOpt_bool = true;
    } else {
      this.overlapOpt_bool = false;
    }
    /*     if (this.barChartForMeas === "True") {
      this.barChartForMeas_bool = true;
    } else {
      this.barChartForMeas_bool = false;
    } */
    return {
      city_compare: comparedCity,
      city_id: cityId,
      indicator: this.dataFilters.indicator,
      services: this.datasetView,
      services_bdg: this.dataFilters.energy_service_bdg,
      energy_type: this.dataFilters.energy_type,
      display_overlapp_meas_data: this.overlapOpt_bool,
      display_meas_data_on_bar_chart: this.barChartForMeas,
      value_type: this.dataFilters.value_type,
      perimeter: this.dataFilters.perimeter,
      network_ind: this.dataFilters.networksInd,
      money_vs_co2: this.dataFilters.money_co2_saved,
      vehicle_fuel: this.dataFilters.vehicleFuel,
      vehicle_type: this.dataFilters.vehicleType,
      action_category: this.dataFilters.actionCategory,
      sia_assignment: this.dataFilters.siaAssignment,
      energetic_agent: this.dataFilters.energeticAgent,
      ghg_scopes_vs_sectors: this.dataFilters.ghgScopesSectors,
      ghg_scope: this.dataFilters.ghgScope,
      ghg_emission_sector: this.dataFilters.emissionSector,
      charts: this.chartsToCompute,
      multi_city: this.multiCity,
      compareBarCharts: COMPARE_BAR,
      pieChartsObjComp: this.comparingYearForPie,
      pieChartsRegionComp: this.comparingRegionForPie,
      year: this.dataFilters.year,
      chart_years: this.chartYears
    };
  }

  update(): void {
    this.logger.log("chartsComponent/update");
    if (!this.helper.isNullOrUndefined(this.dataFilters)) {
      this.updateAllCharts();
    }
  }

  updateAllCharts() {
    // request the data for the charts (using a newly created payload)
    this.chartsService.getCharts(this.createPayload()).then(data => {
      // once the data received
      // update charts one by one using the requested data
      const chartsToUpdate = Object.keys(data);
      chartsToUpdate.forEach(chartId => {
        this.updateChart(chartId, data[chartId]);
      });
    });
  }

  updateChart(idOfChartData, data) {
    this.deleteChartData(idOfChartData);
    if (Object.keys(data).length !== 0) {
      // translate region name for the doughnut charts when comparing with region
      if (
        ["mix", "mix_strategy_data", "local", "local_strategy_data", "renewable", "renewable_strategy_data"].includes(idOfChartData) &&
        this.comparePieChartParam == "True" &&
        Object.keys(data).includes(NAME_REGION)
      ) {
        // Translate name of munciipalities and/or region        
        const regionTranslation = this.translateService.instant(
          "DASHBOARD.CHARTS.REGION"
        );
        data[regionTranslation] = data[NAME_REGION];
        var i;
        for (i=0; i < Object.keys(data).length; i++){
          data[Object.keys(data)[i]]['title'] = this.translateService.instant(`CITIES.${Object.keys(data)[i]}`);
        }
      }
      else if (["mix", "mix_strategy_data", "local", "local_strategy_data", "renewable", "renewable_strategy_data"].includes(idOfChartData)){
        var i;
        for (i=0; i < Object.keys(data).length; i++){
          data[Object.keys(data)[i]]['title'] = Object.keys(data)[i];
        }
      }
      this.chartData[idOfChartData] = data;
    }
  }

  deleteChartData(idOfChartData) {
    delete this.chartData[idOfChartData];
  }

  getOrderedParam() {
    if (!this.helper.isNullOrUndefined(this.chartParam)) {
      return this.helper.getOrderedDictByOrderName(this.chartParam);
    }
    return [];
  }

  getOrderedImages() {
    if (!this.helper.isNullOrUndefined(this.imageParam)) {
      return this.imageParam;
    }
    return [];
  }

  getChartTooltipTranslated(id) {
    uikit
      .tooltip("#chart_" + id, {
        title: this.translateService.instant(
          `DASHBOARD.CHARTS.${id}.INFO_TOOLTIP`
        ),
        pos: "right"
      })
      .show();
  }
}
